import { render, staticRenderFns } from "./Fornitore.vue?vue&type=template&id=0f5133e5&"
import script from "./Fornitore.vue?vue&type=script&lang=js&"
export * from "./Fornitore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports